<template>
  <b-row>
    <b-col cols="12">
      <div class="d-flex align-items-center">
        <b-button to="/settings" variant="outline" class="text-primary">
          <feather-icon icon="ArrowLeftIcon" /> Back to Settings
        </b-button>
        <div>
          <h3 class="font-weight-bolder mb-0">Marketing &amp; Promo</h3>
          <p class="text-muted mb-0">
            Configure system settings for marketing and promotions default
            values
          </p>
        </div>
      </div>
    </b-col>
    <b-col cols="12" lg="4" class="d-flex mt-2">
      <MarketingPromo class="w-100" />
    </b-col>
    <b-col cols="12" lg="4" class="d-flex mt-lg-2">
      <BonusBetTokenSymbol class="w-100" />
    </b-col>
    <b-col cols="12" lg="4" class="d-flex mt-lg-2">
      <TurnoverRebate class="w-100" />
    </b-col>
    <b-col cols="12">
      <TermConditions />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BButton } from "bootstrap-vue";
import MarketingPromo from "../system-configuration/MarketingPromo.vue";
import TermConditions from "./TermConditions.vue";
import BonusBetTokenSymbol from "./BonusBetTokenSymbol.vue";
import TurnoverRebate from "./TurnoverRebate.vue";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    MarketingPromo,
    TermConditions,
    BonusBetTokenSymbol,
    TurnoverRebate,
  },
};
</script>
